import {LinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';
import {mockLinkedAccounts} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/mocks/mocks';
import {Table} from '/ui/components/table/table';


/**
 * @dict
 * @typedef {{
 *   linkedAccount: (LinkedAccount | undefined),
 *   setLinkedAccount: function(LinkedAccount): void,
 * }}
 */
export let LinkedAccountsTableProps;

/**
 * @param {LinkedAccountsTableProps} props
 */
export function LinkedAccountsTable(props) {
  /**
   * @param {string} rowId
   */
  function isSelected(rowId) {
    return props.linkedAccount !== undefined
      && props.linkedAccount.id === parseInt(rowId, 10);
  }

  /**
   * @param {string} rowId
   * @param {boolean} _
   */
  function onSelectRow(rowId, _) {
    const selectedLinkedAccount = mockLinkedAccounts.find(linkedAccountRow =>
      linkedAccountRow.id === parseInt(rowId, 10));
    if (selectedLinkedAccount !== undefined) {
      props.setLinkedAccount(selectedLinkedAccount);
    }
  }

  const numSelected = props.linkedAccount === undefined ? 0 : 1;

  const selectedIds = props.linkedAccount === undefined
    ? new Set()
    : new Set([props.linkedAccount.id.toString()]);

  const rowSelectionOptions = {
    isSelected: isSelected,
    onSelectRow: onSelectRow,
    numSelected,
    selectedIds,
    isSingleSelect: true,
  };

  return (
    <Table
      columns={getColumns()}
      dataRows={getLinkedAccountRows(mockLinkedAccounts)}
      label={yext.msg('Linked Account Table')}
      rowSelectionOptions={rowSelectionOptions}
    />
  );
}


const COLUMN_IDS = {
  NAME: 'name',
  EMAIL: 'email',
};

function getColumns() {
  return [
    {
      id: COLUMN_IDS.NAME,
      label: yext.msg('Name'),
    },
    {
      id: COLUMN_IDS.EMAIL,
      label: yext.msg('Email'),
    },
  ];
}

/**
 *
 * @returns
 */
function getLinkedAccountRows(linkedAccounts) {
  return linkedAccounts.map(getLinkedAccountRow);
}

/**
 * @param {LinkedAccount} linkedAccount
 */
function getLinkedAccountRow(linkedAccount) {
  return {
    id: linkedAccount.id.toString(),
    [COLUMN_IDS.NAME]: linkedAccount.name,
    [COLUMN_IDS.EMAIL]: linkedAccount.emailAddress,
  };
}
